import React from 'react';

const SubmitButton = ({ handleSubmit, classNames, isDisabled = false, error, label }) => {
  return (
    <>
      <button
        type="button"
        onClick={handleSubmit}
        className={classNames}
        disabled={isDisabled}
      >
        {label}
      </button>
      {error && <p className="body-4 mt-6 text-center text-error">{error}</p>}
    </>
  );
};

export default SubmitButton;
